export const log = (...args: any[]) => {
  if (!window.pyneSettings?.debug) return;
  console.log("PYNE:", ...args);
};

export const debugLog = (...args: any[]) => {
  if (!window.pyneSettings?.debug) return;
  console.log("%cPYNE DEBUG:", "color: blue;", ...args);
};
